export default "__VITE_ASSET__DfnaQc62__"